const BASE_URL = 'https://creativecommons.tankerkoenig.de/json';

export const tankerkoenigService = {
  /**
   * Search for stations in a radius
   */
  async getNearbyStations(lat, lng, radius, type, apiKey) {
    if (!apiKey) {
      console.warn('Tankerkönig: No API Key provided');
      return [];
    }
    
    // Valid types: 'e5', 'e10', 'diesel', 'all'
    // API requires explicit type for search, but 'all' works for list.php in some versions, 
    // however for safety we use 'all' if supported or default to 'e5' if strict.
    // The error "nur 'dist' und 'price' als sort Parameter erlaubt" was fixed by setting sort='dist'.
    const fuelType = type === 'all' ? 'all' : type;
    const sort = 'dist'; 
    
    try {
      const url = `${BASE_URL}/list.php?lat=${lat}&lng=${lng}&rad=${radius}&type=${fuelType}&sort=${sort}&apikey=${apiKey}`;
      console.log(`Tankerkönig: Fetching nearby stations from ${url.replace(apiKey, 'HIDDEN')}`);
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.ok) {
        console.log(`Tankerkönig: Found ${data.stations?.length || 0} stations`);
        return data.stations || [];
      } else {
        const errorMsg = data.message || 'Unbekannter Fehler von der API';
        console.error('Tankerkönig API Error:', errorMsg, data);
        return []; 
      }
    } catch (error) {
      console.error('Tankerkönig Network/JSON Error:', error);
      return [];
    }
  },

  /**
   * Get current prices for specific stations
   */
  async getStationPrices(stationIds, apiKey) {
    if (!apiKey || !stationIds || stationIds.length === 0) return {};
    
    try {
      const ids = stationIds.join(',');
      const url = `${BASE_URL}/prices.php?ids=${ids}&apikey=${apiKey}`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.ok) {
        return data.prices || {};
      } else {
        console.error('Tankerkönig Price API Error:', data.message || 'Unknown error');
        return {};
      }
    } catch (error) {
      console.error('Tankerkönig Price Network Error:', error);
      return {};
    }
  },

  /**
   * Helper to geocode address to lat/lng (using OpenStreetMap Nominatim)
   */
  async geocodeAddress(address) {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`);
      const data = await response.json();
      
      if (data && data.length > 0) {
        return {
          lat: parseFloat(data[0].lat),
          lng: parseFloat(data[0].lon),
          display_name: data[0].display_name
        };
      }
      return null;
    } catch (error) {
      console.error('Geocoding Error:', error);
      return null;
    }
  }
};

export default tankerkoenigService;